<template>
  <div>


    <el-card>
      <div v-loading="loading" style="width: 100%">
        <el-card class="start-card1">
          <ul class="start-desc-list1">
            <li>{{ $t('TITLE_LIST_1') }}</li>
            <li>{{ $t('TITLE_LIST_3') }}</li>

          </ul>
        </el-card>

        <br />


        <el-card class="start-card2">
          <div class="start-desc-title">{{ $t('not_applicable') }}</div>
          <el-divider>

          </el-divider>
          <ul class="start-desc-list2">

            <li>{{ $t('TITLE_LIST_4') }}</li>
            <li>{{ $t('TITLE_LIST_5') }}</li>
            <li>{{ $t('TITLE_LIST_6') }}</li>
          </ul>
        </el-card>


        <div v-show="!loading">

          <el-divider></el-divider>

          <div>

            <el-button v-show="!showDeptList" type="primary" class="start-btn" @click="handleShowDepts"> ▼ {{
              $t('SHOW_JOIN_DEPTS') }}
            </el-button>

            <div v-show="showDeptList">
              <el-button type="primary" class="start-btn" @click="handleShowDepts"> ▲ {{ $t('HIDE_JOIN_DEPTS')
              }} </el-button>
              <br />
              <br />
              <el-card class="dept-list-box">

                <ol type="2" class="start-dept-list">

                  <div v-for="dept in deptList" :key="dept.id">
                    <li class="dept_txt">{{ dept.text }} </li>
                    <pre v-if="dept.desc" :class="deptDescClass(dept.id)"> {{ dept.desc }} </pre>
                  </div>
                </ol>
              </el-card>
            </div>
          </div>

          <el-divider></el-divider>

          <p>
            <el-button type="primary" @click="startEditAddress" class="start-btn">
              {{ registered ? $t("START_BTN_MODIFICATION") : $t("START_BTN_REGISTER") }}
            </el-button>
          </p>


          <p v-if="registered">
            <el-button type="primary" @click="$router.push('/enquiry')" class="start-btn">
              {{ $t("START_BTN_ENQUIRY") }}
            </el-button>
          </p>
        </div>

        <br />

      </div>
    </el-card>
  </div>
</template>

<script>

import { getLocale } from "@/i18n.js";

import { getGovmoLoginURL } from "@/api/user.js";
import { getDeptData, isRegistered } from "@/api/contact.js";

import { ServerBaseURL } from "../config.js";
import { env } from "../config.js";

export default {
  data() {
    return {
      loading: true,
      registered: false,
      deptList: [],
      deptListData: [],
      showDeptList: false,
    };
  },

  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      if (oldVal != newVal) {
        this.genDeptList();
      }
    }
  },

  async mounted() {
    window.JsApi.Page.setTitleVisible(true);
    await this.setupDeptData();
    await this.checkRegister();
  },

  methods: {
    startEditAddress() {
      if (this.registered) {
        this.$router.push('/edit-address')
      } else {
        this.$router.push('/edit-address?first=true')
      }
    },

    deptDescClass(dept) {
      return dept !== "SAFP" ? "dept_desc_txt" : "dept_desc_txt2";
    },

    handleShowDepts() {
      this.showDeptList = !this.showDeptList;
    },

    async setupDeptData() {
      let { data } = await getDeptData();

      this.deptListData = data || [];
      this.genDeptList();
    },

    async genDeptList() {
      const lang = getLocale();
      this.deptList = this.deptListData.map(x => ({ id: x.id, text: x[lang + 'name'], desc: x[lang + 'desc'] }));
    },

    async getGovMoToken() {
      if (this.$govapp && this.$govapp.getToken) {
        const govapp = this.$govapp;
        return new Promise((resolve) => {
          govapp.getToken({
            success(res) {
              console.log('getToken:', res)
              resolve(res.authToken);
            },
            fail() {
              resolve(undefined);
            },
          });
        });
      }
      return undefined;
    },

    async govmoLogin(redirectPath) {
      this.loading = true;
      const lang = getLocale();
      const token = await this.getGovMoToken();
      console.log("getGovMoToken:", token);
      if (token) {
        const loginUrl = `${ServerBaseURL}/govmo-login-token?env=${env}&lang=${lang}&token=${token}&redirectPath=${redirectPath}`;
        console.log("login url:", loginUrl);
        window.location.href = loginUrl;
      } else {
        const { data } = await getGovmoLoginURL(lang, env, redirectPath);
        if (data) {
          console.log("login url:", data.url);
          window.location.href = data.url;
        }
      }
    },

    async checkRegister() {
      let isSucessFlag = false;
      this.loading = true;
      try {
        const { data } = await isRegistered();
        if (data) {
          if (data.status == 'login_require') {
            isSucessFlag = true;
            this.govmoLogin('start');
            return
          } else if (data.status == "ok") {
            isSucessFlag = true;
            console.log('checkRegister:', data)
            this.registered = data.registered;
            this.$nextTick(() => { this.loading = false });
          }
        }
      } finally {
        if (!isSucessFlag) {
          this.$message.error(this.$t("request_fail"));
        }
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.dept-list-box {
  background-color: rgba(19, 160, 123, 0.3);


}

.start-btn {
  border-radius: 20px;
  width: 100%;
  font-size: 18px;
  white-space: normal;
  word-wrap: break-word;

  span {
    font-size: 22px;
  }
}



.start-card1 {
  background-color: rgba(19, 160, 123, 0.3);

  .start-desc-list1 {
    list-style: disc;
    margin-inline-start: 1em;

  }

}

.dept_txt {
  margin-top: 15px;
}


.start-card2 {
  background-color: rgba(247, 216, 216, 0.8);

  .start-desc-list2 {
    list-style: disc;
    margin-inline-start: 1em;
    color: rgb(252, 66, 66);
  }


  .el-divider {
    background-color: rgb(252, 66, 66);
  }

  .start-desc-title {

    color: rgb(252, 66, 66);
    font-weight: bold;
    text-align: center;
    width: 100%;
    margin-bottom: -15px;
  }
}

.start-dept-list {
  list-style: disc;
  margin-inline-start: 2em;

  pre {
    white-space: pre-line;
    text-indent: 0;
  }
}



.dept_desc_txt {
  margin: 1px;
  color: rgb(252, 66, 66);
  text-indent: -7px;
  font-size: 12px;
  word-break: normal;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-family: "PingFang SC";
}


.dept_desc_txt2 {
  margin: 1px;
  color: rgba(0, 0, 0, 0.8);
  text-indent: -7px;
  font-size: 12px;
  word-break: normal;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-family: "PingFang SC";
}
</style>